import { z } from 'zod'

import { flowSchema, timeSeriesSchema } from './segmentInsightsSchemas'

const popularLinkAutomationItemSchema = z.object({
  data: z.array(timeSeriesSchema),
  flow: flowSchema,
  opened: z.number(),
  total: z.number(),
})

export const popularLinkAutomationsSchema = z.object({
  data: z.array(popularLinkAutomationItemSchema),
})

export type PopularLinkAutomationItemSchemaType = z.infer<typeof popularLinkAutomationsSchema>
